import { createContext } from "react";

const HouseContext = createContext([]);

export default HouseContext;
